/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AdminBedTypeDto, AdminBedTypeRequestDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminBedTypeService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminBedTypeService
   * @name GetBedType
   * @summary Get BedType by ID
   * @request GET:/v1/admin/bed-types/{bedTypeId}
   * @secure
   */
  getBedType = (bedTypeId: number, params: RequestParams = {}) =>
    this.http.request<AdminBedTypeDto, any>({
      path: `/v1/admin/bed-types/${bedTypeId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBedTypeService
   * @name UpdateBedType
   * @summary Update BedType
   * @request PUT:/v1/admin/bed-types/{bedTypeId}
   * @secure
   */
  updateBedType = (bedTypeId: number, data: AdminBedTypeRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminBedTypeDto, any>({
      path: `/v1/admin/bed-types/${bedTypeId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBedTypeService
   * @name DeleteBedType
   * @summary Delete BedType
   * @request DELETE:/v1/admin/bed-types/{bedTypeId}
   * @secure
   */
  deleteBedType = (bedTypeId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/bed-types/${bedTypeId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBedTypeService
   * @name GetBedTypes
   * @summary Get BedTypes
   * @request GET:/v1/admin/bed-types
   * @secure
   */
  getBedTypes = (
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminBedTypeDto[], any>({
      path: `/v1/admin/bed-types`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminBedTypeService
   * @name CreateBedType
   * @summary Create BedType
   * @request POST:/v1/admin/bed-types
   * @secure
   */
  createBedType = (data: AdminBedTypeRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminBedTypeDto, any>({
      path: `/v1/admin/bed-types`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
